export const getBaseHref = () => {
    const baseElement = document.getElementsByTagName('base')[0] as
        | HTMLBaseElement
        | undefined;

    return baseElement?.href.replace(/\/$/, '') ?? '';
};
